import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import PagePagePC from './PagePagePC';
import PagePage from '../../common/models/PagePage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import Button from 'flarum/components/Button';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import SelectDropdown from 'flarum/common/components/SelectDropdown';
import LinkButton from 'flarum/common/components/LinkButton';
import sortTags from 'flarum/tags/common/utils/sortTags';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Search from 'flarum/forum/components/Search';
import SearchView from './SearchView';
import username from 'flarum/common/helpers/username';
import nickname from 'flarum/common/helpers/nickname';
import highlight from 'flarum/common/helpers/highlight';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';
import Placeholder from 'flarum/common/components/Placeholder';
import signName from 'flarum/forum/dianLiang/signName';

//主页PostsSearchView
export default class UsersSearchView extends SearchView {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--page';
    this.loading = true;
    this.query = this.attrs.q ? this.attrs.q : '';
    this.results = new Map();
    // this.search(this.query)
    this.query = this.query.toLowerCase();

    this.results = (this.results.get(this.query) || [])
      .concat(
        app.store
          .all('users')
          .filter((user) => [user.username(), user.nickname()].some((value) => value.toLowerCase().substr(0, this.query.length) === this.query))
      )
      .filter((e, i, arr) => arr.lastIndexOf(e) === i)
      .sort((a, b) => a.nickname().localeCompare(b.nickname()));

    app.discussions.refreshParams(app.search.params(), (m.route.param('page') && Number(m.route.param('page'))) || 1);
    app.history.push(`${this.attrs.routeName}`);
  }

  title() {
    return (
      <h4 className="App-titleControl search-title">
        <Search state={app.search} />
      </h4>
    );
  }

  async search(query) {
    return app.store
      .find('users', {
        filter: { q: query },
        page: { limit: 5 },
      })
      .then((results) => {
        this.results.set(query, results);
        m.redraw();
      });
  }

  content() {
    if (!this.results.length) return <Placeholder text={app.translator.trans('core.forum.discussion_list.empty_text')} />;

    return [
      // <li className="Dropdown-header">{app.translator.trans('core.forum.search.users_heading')}</li>,
      ...this.results.map((user) => {
        const name = nickname(user);

        const children = [highlight(name.text, this.query)];
        let userLevel = user?.userLevel();
        let levelImg = undefined;
        let levelImgs;
        let levelImgRes;
        let levelColor;
        let levelColors
        let levelColorRes;
        if (userLevel) {
          levelImgs =  userLevel?.levelConf()?.levelImg();
          if (levelImgs) {
            levelImgRes  = JSON.parse(levelImgs);
            levelImg = levelImgRes[app.data.pkgLogo.id];
          }
          levelColors =  userLevel?.levelConf()?.color();
          if (levelColors) {
            levelColorRes  = JSON.parse(levelColors);
            levelColor = levelColorRes[app.data.pkgLogo.id];
          }
        } else {
          try {
            levelImgs = user.data.attributes.levelConf.level_img;
            if (levelImgs) {
              levelImgRes  = JSON.parse(levelImgs);
              levelImg = levelImgRes[app.data.pkgLogo.id];
            }
            levelColors =  user.data.attributes.levelConf.color();
            if (levelColors) {
              levelColorRes  = JSON.parse(levelColors);
              levelColor = levelColorRes[app.data.pkgLogo.id];
            }
          } catch (e) {
            console.log(e);
          }
        }
        return (
          <li className="extra-userSearchResult" data-index={'users' + user.id()}>
            <Link href={app.route.user(user)} className="extra-userSearchResult-container">
              {avatar(user)}
              <div className="extra-userSearchResult-right">
                <div className="extra-userSearchResult-text">
                  <div className="extra-userSearchResult-text-username">{{ ...name, text: undefined, children }}</div>
                  {user.badges().toArray().length > 0 && <ul className="DiscussionListItem-badges badges">{listItems(user.badges().toArray())}</ul>}
                  <div className="extra-userSearchResult-text-grade">
                    <img src={levelImg}></img>
                    <span
                      className="extra-userSearchResult-text-grade-lv"
                      style={`text-shadow: -1px -1px 0 ${levelColor}, 1px -1px 0 ${levelColor}, -1px 1px 0 ${levelColor}, 1px 1px 0 ${levelColor};`}
                    >
                      {userLevel?.levelConf()?.level()}
                    </span>
                    {/* <span className="extra-userSearchResult-text-grade-lv">{userLevel?.levelConf()?.level()}</span> */}
                  </div>
                </div>
                {signName(user)}
              </div>
            </Link>
          </li>
        );
      }),
    ];
  }
}
